export default "__VITE_ASSET__UOmgBs5J__"